import LOGO from "../images/Adrianes.png";

export const Team__Adrianes = {
  name: "Adrianes",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#E31E24",
  teamJerseyColor: "#666666",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 25 + 28 + 13,
  goalsScoredAgainst: 37 + 38 + 39,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
